import { createSlice } from "@reduxjs/toolkit";
import { TypeUser } from "@/types";
import { getCookie, setCookie } from "@/utils";

type typeAuth = {
  user: TypeUser;
};

const initialState: typeAuth = {
  user: getCookie("user"),
};

export const selectedSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.user = action.payload;
      setCookie("user", action.payload);
    },
  },
});
export const { setUser } = selectedSlice.actions;
// Other code such as selectors can use the imported `RootState` type
export const getUser = (state: typeAuth) => state.user;

export default selectedSlice.reducer;
